import moment from 'jalali-moment'
import { toast } from 'react-toastify';
import userDefaultImage from '../assets/images/img/userDefault.png';
import menuDefaultImage from '../assets/images/img/menu_default_img.svg';
import imageNotAvailable from "../assets/images/img/Image_not_available.png"
import branchDefault from "../assets/images/img/branchDefault.svg"
import menu from "../assets/images/img/menu.png"
import logoDefault from "../assets/images/img/defaultLogo.png"

const methods = {
  toPersianDate: function (dt, format) {
    if (this.isNullOrEmptyString(dt))
      return '';
    if (format != undefined && format != '')
      return moment(dt).format(format);
    return moment(this.bDateModel).format('jYYYY/jMM/jDD');
  },
  getNowDateTime: function (format) {
    return this.toPersianDate(new Date(), format);
  },
  toEnNumbers: function (str) {
    if (str === undefined || str == null || str === '') {
      return '';
    }
    return str.toString().replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d));
  },
  toFaNumbers: function (str) {
    if (str === undefined || str == null || str === '') {
      return '';
    }
    return str.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
  },
  addNumSeperator: function (str) {
    if (str === undefined || str == null || str === '') {
      return '';
    }
    return this.allReplace(str.toString(), ',', '').replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  allReplace: function (str, find, replace) {
    if (str === undefined || str == null || str === '') {
      return '';
    }
    str = str.toString();
    return str.replace(new RegExp(find, 'g'), replace);
  },
  convertToNumber: function (num) {
    if (this.isNullOrEmptyString(num))
      return 0;
    var strNum = num.toString();
    var normalValue = this.allReplace(strNum, ',', '');
    var normalNum = parseInt(normalValue);

    if (!isNaN(normalNum))
      return normalNum;
    else
      return 0;
  },
  getTaxAmount: function (percent, amount) {
    if (amount === 0)
      return 0;
    return parseInt((amount * percent) / 100);
  },
  textLimit(txt, len, endStr) {
    if (this.isNullOrEmptyString(txt))
      return "";
    if (txt.length <= len)
      return txt;
    return txt.substring(0, len - 1) + endStr;
  },
  charLimit: function (strChars, limit) {
    return strChars.substring(0, limit);
  },
  isNullOrEmptyString: function (str) {
    if (str === undefined || str === null || str === '')
      return true;
    else
      return false;
  },
  getUserInfoFromToken: function () {
    try {
      let userInfo = JSON.parse(localStorage.userInfo);
      return userInfo;
    }
    catch {
      return null;
    }
  },
  normalImage: function (strImage, type) {
    let defaultImage;

    switch (type) {
      case 'avatar':
        defaultImage = userDefaultImage;
        break;
      case 'menu':
        defaultImage = menu;
        break;
      case 'branch':
        defaultImage = branchDefault;
        break;
      case 'unit':
        defaultImage = imageNotAvailable;
        break;
      case 'logo':
        defaultImage = logoDefault;
        break;
      default:
        defaultImage = imageNotAvailable;
        break;
    }

    if (this.isNullOrEmptyString(strImage))
      return defaultImage;
    else
      return process.env.REACT_APP_ADMIN_PANEL_API + '/' + strImage;
  },
  // normalAvatar: function (strAvatar) {
  //   if (this.isNullOrEmptyString(strAvatar))
  //     return require('../assets/images/img/userDefault.png');
  //   else
  //     return process.env.REACT_APP_ADMIN_PANEL_API + '/' + strAvatar;
  // },
  // normalImgSrc: function (strSrc) {
  //   if (this.isNullOrEmptyString(strSrc))
  //     return require('../assets/images/img/userDefault.png');
  //   else
  //     return process.env.REACT_APP_ROOT_USER_API + '/' + strSrc;
  // },
  getPercentAmount: function (amount, percent) {
    if (percent == 0 || amount == 0)
      return 0;
    return parseInt((amount * percent) / 100);
  },
  getDiscountAmount: function (course) {
    return this.getPercentAmount(course.price, course.adminDiscount) + this.getPercentAmount(course.price, course.teacherDiscount);
  },
  getPaymentAmount: function (course) {
    return course.price - this.getDiscountAmount(course);
  },
  getUserStorageInfo: function () {
    if (!this.isNullOrEmptyString(localStorage.userInfo))
      return JSON.parse(localStorage.userInfo);
    else
      return null;
  },
  setToken: function (userInfo) {
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  },
  currentDate: function () {
    return moment().locale('fa').format('dddd jD jMMMM jYYYY');
  },
  convertToJalali: function (dateTime) {
    return moment(dateTime).format('jYYYY-jMM-jDD\u00A0\u00A0\u00A0\u00A0HH:mm:ss');
  },
  checkUserLogin: function () {
    let userInfo = this.getUserStorageInfo();
    if (userInfo === null || userInfo === undefined || !userInfo) {
      return false;
    }
    let currentDate = moment().locale('fa');
    let expireDate = moment(userInfo.expireDate, 'YYYY-MM-DD');
    if (currentDate.isAfter(expireDate)) {
      return false;
    }
    return true;
  },
  getUserRoles: function () {
    let userInfo = this.getUserStorageInfo();
    if (userInfo === null)
      return [];
    return userInfo.roles;
  },
  checkSalesUserRoles: function (roles) {
    if (roles === null || roles === undefined || roles.length === 0)
      return false;
    var accessNames = ["RestaurantAdmin", "BranchAdmin", "SaleAdmin", "Cashier"];
    let res = false;
    roles.forEach(item => {
      if (accessNames.includes(item.name))
        res = true;
    });
    return res;
  },
  routeAfterLogin: function () {
    let roles = this.getUserRoles();
    if (roles.length === 0)
      return "/login";
    if (roles.some(x => x.name === "Waiter") && roles.length === 1)
      return "/waiterpanel";
    if (roles.some(x => x.name === "Delivery") && roles.length === 1)
      return "/DeliveryPanel";
    if (roles.some(x => x.name === "ShippingStaff") && roles.length === 1)
      return "/shipping";
    if (roles.some(x => x.name === "Kitchen") && roles.length === 1)
      return "/kitchen";

    if (this.checkSalesUserRoles(roles))
      return "/resturants";

    return "*"
  },
  showErrors: function (messages) {
    messages.forEach((item) => {
      toast.error(item, {
        position: "top-right",
        autoClose: 1000,
        theme: "colored",
        style: {
          backgroundColor: "#FBE7E7",
          color: "#D00707"
        },
        progressClassName: "progressBarColor",
      })
    });
  },
  showSuccesses: function (messages) {
    messages.forEach((item) => {
      toast.success(item, {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    });
  },
  showApiErrors: function (resp) {
    if (resp.status != 200) {
      if (Array.isArray(resp.messages))
        this.showErrors(resp.messages);
      return false;
    }
    return true;
  },
  base64Normalize: function (b64Uri) {
    var b64Prefix = "data:image/jpeg;base64,";
    return b64Uri.substring(b64Prefix.length, b64Uri.length);
  },
  logout: function () {
    if (this.checkUserLogin()) {
      localStorage.removeItem('userInfo');
      localStorage.removeItem('restaurant');
    }
    return "/Login";
  },
  getRestaurantInfo() {
    const restaurantInfo = JSON.parse(localStorage.getItem("restaurant"));
    return restaurantInfo;
  },
  setRestaurantInfo(model) {
    localStorage.setItem("restaurant", JSON.stringify(model));
  },
  getWaiterPanelInfo() {
    const restaurantInfo = JSON.parse(localStorage.getItem("waiter"));
    return restaurantInfo;
  },
  setWaiterPanelInfo(model) {
    localStorage.setItem("waiter", JSON.stringify(model));
  },
  calcPageParts(total, size) {
    return Math.ceil(total / size);
  },
  validateNumberInput: function (input) {
    return /^[0-9]*$/.test(input.toString());
  },
  getPersianWeekDays: () => {
    return [
      { title: 'شنبه', id: 1 },
      { title: 'یکشنبه', id: 2 },
      { title: 'دوشنبه', id: 3 },
      { title: 'سه شنبه', id: 4 },
      { title: 'چهار شنبه', id: 5 },
      { title: 'پنج شنبه', id: 6 },
      { title: 'جمعه', id: 7 },
    ];
  },
  getSettingItemByKey: (strSetting, keyName) => {
    var setting = JSON.parse(strSetting);
    var item = setting.find(x => x.KeyName === keyName);
    return item.SettingValue;
  },
  formatPhoneNumber: function (phoneNumber) {
    if (this.isNullOrEmptyString(phoneNumber))
      return "";
    if (phoneNumber.startsWith('+98')) {
      return phoneNumber.replace('+98', '0');
    }
    return phoneNumber;
  },
  validatePhoneNumber: function (number) {
    const phoneNumberRegex = /^09\d{9}$/;
    return phoneNumberRegex.test(number);
  },
  setOrderingStatics(saleUnitId, cashDeskId, orderType) {
    let orderingInfo = {
      cashDeskId: cashDeskId,
      saleUnitId: saleUnitId,
      orderType: orderType
    };
    localStorage.setItem("orderingInfo", JSON.stringify(orderingInfo));
  },
  getOrderingStatics() {
    let orderingInfo = localStorage.getItem("orderingInfo");
    return orderingInfo ? JSON.parse(orderingInfo) : {
      cashDeskId: 0,
      saleUnitId: 0,
      orderType: 0,
    };
  },
  
}

export default methods;